import Link from "next/link";
import NextImage from "../NextImage";
import { validateImgSrc, checkSearchLang } from "@/utils/global";

import { trackProductClickAfterSearch } from "@/utils/searchClients";
import { useRouter } from "next/router";
import ProductLabel from "./ProductLabel";
import { validateProductPrice } from "@/utils/product";
import PriceWithCurrency from "@/components/Helpers/PriceWithCurrency";
import { sanitizeHtml } from "@/utils/sanitizeHtml";

const SearchProductCard = ({
  product,
  clearSearch,
  language,
  inputValue,
  position,
  queryID,
}) => {
  const { locale } = useRouter();

  const price = validateProductPrice(product?.prices_with_tax);

  return (
    <Link
      href={`/product/${product?.rewrite_url}`}
      onClick={() => {
        clearSearch();
        if (queryID) {
          trackProductClickAfterSearch(
            `${product?.objectID}`,
            checkSearchLang(inputValue, locale) === "ar"
              ? process.env.NEXT_PUBLIC_ALGOLIA_IDX_AR
              : process.env.NEXT_PUBLIC_ALGOLIA_IDX_EN,
            queryID,
            position
          );
        }
      }}
      className="flex flex-col gap-1 p-1 pb-2 border rounded-sm"
    >
      <div className="relative">
        <NextImage
          src={validateImgSrc(
            product?._media_?.image?.at(0)?.image ||
              product?.small_image ||
              product?.image_url
          )}
          className="object-contain h-32 mx-auto"
          width={150}
          height={150}
          alt={
            Array.isArray(product?.name) ? product?.name?.at(0) : product?.name
          }
        />
        {product?.label
          ?.filter(
            (el) =>
              el &&
              el?.status === "1" &&
              new Date(el?.active_from) < new Date() < new Date(el?.active_to)
          )
          ?.map((label, i) => (
            <ProductLabel label={label} fromTopTen={false} key={i} />
          ))}
      </div>
      <h6 className="text-xs font-medium ">{product?.brand}</h6>

      {product?._highlightResult?.name?.matchedWords?.length &&
      product?._highlightResult?.name?.matchedWords?.at(0) ? (
        <Link
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              product?._highlightResult?.name?.value
                ?.replace(/<em>/g, "<strong>")
                ?.replace(/<\/em>/g, "</strong>")
            ),
          }}
          href={`/product/${product?.rewrite_url}`}
          className="h-8 text-xs line-clamp-2"
        />
      ) : (
        <Link
          href={`/product/${product?.rewrite_url}`}
          className="h-8 text-xs line-clamp-2"
        >
          {Array.isArray(product?.name) ? product?.name?.at(0) : product?.name}
        </Link>
      )}
      {/* <div className="flex items-center gap-0.5 text-sm">
        <span className="font-semibold">4.5</span>
        <AiFillStar className="w-[10px] h-[10px] mx-[0.25px] text-yellow-400" />
        <span>(2071)</span>
      </div> */}
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-0.5">
          <h4 className="text-sm font-bold flex items-center gap-1">
            <PriceWithCurrency
              amount={price?.discounted_price}
              iconClassName="size-3.5"
              className="gap-1"
            />
          </h4>
          {price?.discounted_price !== price?.original_price && (
            <h6 className="text-xs line-through">{price?.original_price}</h6>
          )}
        </div>
        {price?.discounted_price !== price?.original_price && (
          <span className="bg-blue text-white py-1 px-1.5 rounded-md text-[9px]">
            {price?.discounted_percentage}% {language === "en" ? "Off" : "خصم"}
          </span>
        )}
      </div>
      {/* <span className="text-red w-fit border text-xs rounded-[4px] border-red py-1 px-1.5">
        {language === "en" ? "Available" : "متوفر"}
      </span> */}
    </Link>
  );
};

export default SearchProductCard;
